import { matchHero } from './algorithm';
import { emptyState } from './storage';
import type { Answer, PersistedState } from '../types';

export const RESULT_PREVIEW_PARAM = 'preview';

function isAnswer(value: string): value is Answer {
  return value === 'A' || value === 'B' || value === 'C' || value === 'D';
}

export function decodePreviewAnswers(search: string): Answer[] | null {
  const encoded = new URLSearchParams(search).get(RESULT_PREVIEW_PARAM)?.toUpperCase() ?? '';
  if (encoded.length !== 28 || ![...encoded].every(isAnswer)) return null;
  return [...encoded] as Answer[];
}

export function loadResultPreview(search: string): PersistedState | null {
  const answers = decodePreviewAnswers(search);
  if (!answers) return null;
  return {
    ...emptyState(),
    activated: true,
    currentIndex: 27,
    answers,
    result: matchHero(answers),
  };
}

export function encodePreviewAnswers(answers: Answer[]) {
  if (answers.length !== 28) throw new Error('运营预览链接需要 28 个答案');
  return answers.join('');
}
